import { render, staticRenderFns } from "./kline.vue?vue&type=template&id=5ff75156"
import script from "./kline.vue?vue&type=script&lang=js"
export * from "./kline.vue?vue&type=script&lang=js"
import style0 from "./kline.vue?vue&type=style&index=0&id=5ff75156&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports